export const HEADERS: HeadersInit = {
  "Content-Type": "application/json",
  "X-Hallow-Version": process.env.DOPPLER_PUBLIC_X_HALLOW_VERSION,
  "X-Platform": "web",
};
